/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponse } from "@/types/status";
import { ROUTES } from "@/constants/routes";

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || "http://localhost:3000",
  API_FILE_URL: import.meta.env.VITE_API_FILE_URL || "http://localhost:3000",
  HEADERS: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

export const apiClient = {
  async request<T = any>(
    method: string,
    endpoint: string,
    data?: any,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    const url = new URL(`${API_CONFIG.BASE_URL}${endpoint}`);

    // Get access token from localStorage
    const accessToken = localStorage.getItem("auth-storage");
    let token = null;

    if (accessToken) {
      try {
        const parsedAuth = JSON.parse(accessToken);
        token = parsedAuth?.state?.accessToken;
      } catch (error) {
        console.error("Error parsing auth storage:", error);
      }
    }

    const isFormData =
      typeof FormData !== "undefined" && data instanceof FormData;
    const headers = {
      ...(isFormData ? { Accept: "application/json" } : API_CONFIG.HEADERS),
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(options?.headers || {}),
    } as Record<string, string>;

    let body: any | undefined;
    if (data && (method === "POST" || method === "PUT")) {
      if (isFormData) {
        body = data as FormData;
        // For FormData, let browser set Content-Type with boundary
        if (headers["Content-Type"]) {
          delete headers["Content-Type"];
        }
      } else {
        body = JSON.stringify(data);
      }
    } else if (data && method === "GET") {
      Object.keys(data).forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) {
          url.searchParams.append(key, data[key].toString());
        }
      });
    }

    try {
      const response = await fetch(url.toString(), {
        method,
        headers,
        body,
        credentials: "include",
      });

      // Check for 401 Unauthorized
      if (response.status === 401) {
        // Clear all localStorage
        localStorage.clear();
        // Redirect to login page
        window.location.href = ROUTES.LOGIN;
        return {
          ok: false,
          status: 401,
          statusText: "Unauthorized",
          data: { message: "Phiên đăng nhập đã hết hạn" } as T,
        };
      }

      // Parse JSON response
      const responseData = await response.json().catch(() => ({}));

      return {
        ok: response.ok,
        status: response.status,
        statusText: response.statusText,
        data: responseData,
      };
    } catch (error: any) {
      // Handle network errors
      return {
        ok: false,
        status: 0,
        statusText: "Lỗi kết nối mạng",
      };
    }
  },

  async get<T = any>(
    endpoint: string,
    params?: Record<string, any>,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    return this.request("GET", endpoint, params, options);
  },

  async post<T = any>(
    endpoint: string,
    data?: any,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    return this.request("POST", endpoint, data, options);
  },

  async put<T = any>(
    endpoint: string,
    data?: any,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    return this.request("PUT", endpoint, data, options);
  },
  async patch<T = any>(
    endpoint: string,
    data?: any,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    return this.request("PATCH", endpoint, data, options);
  },
  async delete<T = any>(
    endpoint: string,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    return this.request("DELETE", endpoint, undefined, options);
  },
};
